import Image from 'next/image';
import React, { useState} from 'react';

import FallbackImage1 from './Fallbackbild_Station_1.jpg';
import FallbackImage2 from './Fallbackbild_Station_2.jpg';
import FallbackImage3 from './Fallbackbild_Station_3.jpg';
import FallbackImage4 from './Fallbackbild_Station_4.jpg';
const images = [FallbackImage1, FallbackImage2, FallbackImage3, FallbackImage4];

const StationFallbackImage = ({
  style,
  className,
}: {
  style?: React.CSSProperties;
  className?: string;
}) => {
  const [selectedImageIndex, _setSelectedImageIndex] = useState<number>(Math.floor(Math.random() * images.length));

  return (
    <Image
      src={images?.[selectedImageIndex]}
      height={500}
      width={500}
      alt=""
      style={style}
      className={className}
    />
  );
};

export default StationFallbackImage;
